import React from 'react'
import { GetSoSVJournalArticlesQuery_getSoSVJournalArticles } from '~apollo/queries/sosv/journal-articles/__generated__/GetSoSVJournalArticlesQuery'
import { Module } from '~components/ui/molecules/module'
import { formatUrl, StyledSection } from '~common'
import { StatisticsBar } from '~components/ui/molecules/statistics-bar'
import { Divider } from '~components/ui/atoms/divider'
import { ContentTeaser } from '~components/ui/molecules/content-teaser'
import { useSoSVState } from '~components/pages/widgets/sosv/settings/settings'
import { getPlatformUrl } from '~components/pages/widgets/sosv/utils'

export interface JournalArticlesProps {
  journalArticleMatchingCount: number
  recentJournalArticles?: GetSoSVJournalArticlesQuery_getSoSVJournalArticles[]
  productColors: string[]
}

export const JournalArticles: React.FC<JournalArticlesProps> = ({
  journalArticleMatchingCount,
  recentJournalArticles,
  productColors,
}) => {
  const {
    listId,
    rootListId,
    productGroupId,
    source,
    weighteningType,
    contentTypes,
    timeframe,
    cumulatingType,
    graphType,
    drugSelection = [],
    startDate,
    endDate,
  } = useSoSVState()

  const fullVersionUrl = (journalArticleId?: string): string => {
    const subpage = '/sosv/journal-articles'

    return formatUrl(
      getPlatformUrl() + subpage,
      {
        listId,
        rootSubscriptionId: rootListId,
        weighteningType: weighteningType,
        productGroupId: productGroupId,
        sosvTimeframe: timeframe,
        sosvContentTypes: contentTypes,
        startDate,
        endDate,
        drugSelection,
        journalsSortBy: 'all',
        cumulatingType,
        graphType,
        dataSet: source,
      },
      journalArticleId,
    )
  }

  return (
    <Module.Container>
      <Module.Header linkTo={journalArticleMatchingCount ? fullVersionUrl() : undefined}>
        Journal articles
      </Module.Header>
      <StyledSection data-testid="journal-articles-stats">
        <StatisticsBar.Items
          statistics={[
            {
              name: 'Matched',
              value: journalArticleMatchingCount.toString(),
            },
          ]}
        />
      </StyledSection>
      {!!journalArticleMatchingCount && (
        <>
          <Divider borderType="dotted" />
          <ul>
            {recentJournalArticles?.map((item: GetSoSVJournalArticlesQuery_getSoSVJournalArticles) => (
              <ContentTeaser
                key={item.id}
                asTag="li"
                linkTo={fullVersionUrl(item.id)}
                heading={item.articleTitle}
                subheading={item.journalTitle}
                startDate={item.date}
                teaserPhaseOrType={item.abstractType}
                mentionedProducts={item.mentions
                  .map((mention, i) => ({
                    name: mention.productName,
                    count: mention.count,
                    denominationColor: productColors[i],
                  }))
                  .filter((mention) => mention.count)}
              />
            ))}
          </ul>
          <Module.Footer
            links={[
              {
                name: `View all ${journalArticleMatchingCount} journal articles`,
                id: 'journal-articles',
                href: fullVersionUrl(),
              },
            ]}
          />
        </>
      )}
    </Module.Container>
  )
}
